<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      :gradient="sidebarOverlayGradiant"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="logo"
              height="34"
              contain
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{ adminUser.name }}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-if="responsive"
        >
          <v-text-field
            class="green-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile avatar class="v-list-item" :to="'/dashboard'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Dashboard'"
          />
        </v-list-tile>

         <v-list-tile v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 3" avatar class="v-list-item" :to="'/daily-quiz'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Daily Quiz'"
          />
        </v-list-tile>

         <!-- <v-list-tile avatar class="v-list-item" :to="'/latex-test'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Latex Test'"
          />
        </v-list-tile> -->

        
 

         <v-list-tile avatar v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 1" class="v-list-item" :to="'/crash-course'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Crash Course'"
          />
        </v-list-tile>
         <v-list-tile avatar v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 1" class="v-list-item" :to="'/crash-course-subject'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Crash Course Subject'"
          />
        </v-list-tile>

         <v-list-tile avatar v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 1" class="v-list-item" :to="'/crash-course-material'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Crash Course Material'"
          />
        </v-list-tile>

        <!-- <v-list-tile avatar class="v-list-item" :to="'/crash-course-payment'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Crash Course Payment'"
          />
        </v-list-tile> -->

        <v-list-tile avatar v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 2" class="v-list-item" :to="'/all-payments'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'All Payments'"
          />
        </v-list-tile>

         <v-list-tile avatar v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 1" class="v-list-item" :to="'/special-model-test'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Special Model Test'"
          />
        </v-list-tile>

         <v-list-tile avatar v-if="adminUser.role_sequence < 2" class="v-list-item" :to="'/send-message'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Send Message'"
          />
        </v-list-tile>

         <v-list-tile avatar v-if="adminUser.role_sequence === 0" class="v-list-item" :to="'/delete-message'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Delete Message'"
          />
        </v-list-tile>

         <v-list-tile avatar v-if="adminUser.role_sequence === 0" class="v-list-item" :to="'/user-list'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Users'"
          />
        </v-list-tile>

         <v-list-tile v-if="adminUser.role_sequence === 0  || adminUser.role_sequence === 1" avatar class="v-list-item" :to="'/courses'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-arrange-bring-forward</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Courses'"
          />
        </v-list-tile>
         <v-list-tile v-if="adminUser.role_sequence === 0  || adminUser.role_sequence === 1" avatar class="v-list-item" :to="'/subjects'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-book</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Subjects'"
          />
        </v-list-tile>
         <v-list-tile v-if="adminUser.role_sequence === 0  || adminUser.role_sequence === 1 || adminUser.username === 'amimul' || adminUser.username === 'kamal'" avatar class="v-list-item" :to="'/chapters'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-book</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Chapters'"
          />
        </v-list-tile>
         <v-list-tile avatar v-if="adminUser.role_sequence === 0  || adminUser.role_sequence === 1" class="v-list-item" :to="'/quiz'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-book</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Quiz'"
          />
        </v-list-tile>
         <v-list-tile avatar v-if="adminUser.role_sequence === 0  || adminUser.role_sequence === 1"  class="v-list-item" :to="'/lecture-sheet'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-book</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Lecture Sheet'"
          />
        </v-list-tile>
         <!-- <v-list-tile v-if="adminUser.role_sequence === 0 || adminUser.role_sequence === 1" avatar class="v-list-item" :to="'/payment'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-cash-usd</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'Payment'"
          />
        </v-list-tile> -->
         <v-list-tile v-if="adminUser.role_sequence < 2" avatar class="v-list-item" :to="'/lms'" :active-class="color">
          <v-list-tile-action >
            <v-icon>mdi-cash-usd</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="'LMS'"
          />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: '/img/vuetifylogo.png',
    responsive: false,
    adminUser: {}
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant () {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  created () {
    let cookie = null
    cookie = this.getCookie('Info')
    this.adminUser = JSON.parse(cookie)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
          var c = ca[i].trim()
            if (c.indexOf(name)==0) return c.substring(name.length,c.length)
      }
      return "";
  }  
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }
  }
</style>
